import { Outlet } from "react-router-dom";
export const AuthPage = () => {
  return (
    <>
      <Outlet />
    </>
  );
};
